<button
  [class]="hostClass"
  [type]="type"
  [routerLink]="routerLink"
  [attr.title]="title || null"
  [attr.aria-label]="ariaLabel || label || null"
  [disabled]="disabled || loading"
  (click)="handleClick($event)">

  <span *ngIf="loading" class="app-btn__spinner">
    <i class="pi pi-spin pi-spinner"></i>
  </span>

  <span *ngIf="icon && !loading" class="app-btn__icon">
    <i [class]="'pi pi-' + icon"></i>
  </span>

  <span *ngIf="label" class="app-btn__label">{{ label }}</span>

  <ng-content></ng-content>
</button>
